import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { isArchivedFilter } from '../data'

interface DueOutStatusMetadata {
  StatusCode: string
  StatusDescription: string
}
interface DueOutStatusMetadataArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: 'StatusCode' | 'StatusDescription'
}
const LIST_NAME = 'DueOutStatusMetadataList'

const COLUMN_NAMES = {
  StatusCode: 'StatusCode',
  StatusDescription: 'StatusDescription',
}

const STATUS_CODE = {
  CANCELED: 'CANCELED',
  CLOSED: 'CLOSED',
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
  SAVED: 'SAVED',
}

const getDueOutStatusMetadata = async (
  args: DueOutStatusMetadataArgs
): Promise<DueOutStatusMetadata[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.StatusCode

  const items = await list
    .query()
    .filter(filter)
    .select(COLUMN_NAMES.StatusCode, COLUMN_NAMES.StatusDescription)
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as DueOutStatusMetadata[]
}

export {
  COLUMN_NAMES,
  type DueOutStatusMetadata,
  type DueOutStatusMetadataArgs,
  LIST_NAME,
  STATUS_CODE,
  getDueOutStatusMetadata,
}
